export default {"src":"/_next/static/media/ftmscan.53d2d1a4.svg","height":256,"width":256,"blurWidth":0,"blurHeight":0};